import React from 'react';
import { loading_mp4 } from '../../../utils/config'

interface Iprops {
  pClassName?: string
  loading?: boolean
}

function Loading(props: Iprops) {
  const {
    loading,
    pClassName
  } = props
  return (
    <div className={` fixed w-[100vw] h-[100vh] top-0 left-0 flex justify-center items-center z-50 ${pClassName} ${loading ? '' : 'hidden'}`}>
        <video
            src={loading_mp4}
            autoPlay
            loop
            className=' w-[100px]'
            muted
        />
    </div>
  );
}

export default Loading;
